<template>
  <v-form ref="employeeForm" v-model="valid" :lazy-validation="lazy">
    <v-row dense>
      <v-col cols="4">
        <v-text-field
          outlined
          dense
          :rules="inputRules"
          label="Name"
          v-model="record.name"
        ></v-text-field>
      </v-col>

      <v-col cols="4">
        <v-text-field
          outlined
          dense
          :rules="inputRules"
          label="Phone No"
          v-model="record.phone_number"
        ></v-text-field>
      </v-col>

      <v-col cols="4">
        <v-text-field
          outlined
          dense
          :rules="inputRules"
          label="Email"
          v-model="record.email"
        ></v-text-field>
      </v-col>

      <v-col cols="4">
        <v-text-field
          outlined
          dense
          :rules="inputRules"
          label="Id No"
          v-model="record.idNo"
        ></v-text-field>
      </v-col>

      <v-col cols="4">
        <v-text-field
          outlined
          dense
          :rules="inputRules"
          label="User Name"
          v-model="record.userName"
        ></v-text-field>
      </v-col>

      <v-col cols="4">
        <v-text-field
          outlined
          dense
          :rules="inputRules"
          label="Password/PIN No"
          v-model="record.userPin"
        ></v-text-field>
      </v-col>

      <v-col cols="12">
        <v-btn
          v-if="docCreate == true"
          color="primary"
          @click="sendData"
          :loading="$store.state.btnLoader"
        >
          <v-icon left>mdi-content-save</v-icon> Create Employee
        </v-btn>

        <v-btn v-else color="primary" @click="sendData">
          <v-icon left>mdi-content-save</v-icon>Update
        </v-btn>
      </v-col>
    </v-row>
    <snackbar ref="snackbar"></snackbar>
  </v-form>
</template>

<script>
export default {
  props: {
    initial: {
      type: Object,
      required: true,
    },
    docCreate: {
      type: Boolean,
    },
  },
  data: () => ({
    valid: false,
    lazy: false,
    record: {},
    sellOnCredit: true,
    inputRules: [(v) => !!v || "Required"],
    stores: [],
    storesArray: [],
    date: new Date().toISOString().substr(0, 10),
    roles: [
      { name: "Subscriber", role: 3 },
      { name: "Admin", role: 2 },
      { name: "Cashier", role: 1 },
    ],
  }),
  watch: {
    initial: {
      handler: "init",
      immediate: true,
    },
  },
  methods: {
    init(val) {
      if (val) {
        this.record = { ...val };

        if (val.sellOnCredit == "Y") {
          this.sellOnCredit = true;
        }

        if (val.sellOnCredit == "N") {
          this.sellOnCredit = false;
        }
      }
    },
    setDate(date) {
      this.record.date = date;
    },
    async sendData() {
      if (!this.$refs.employeeForm.validate()) {
        this.$refs.snackbar.show("Please fill all the fields", "red");
        return;
      }
      this.record.userType = 0;
      if (this.sellOnCredit == true) {
        this.record.sellOnCredit = "Y";
      }

      if (this.sellOnCredit == false) {
        this.record.sellOnCredit = "N";
      }

      this.$store.commit("btnLoader", true);
      this.$emit("data", this.record);
    },
  },
  created() {},
};
</script>
